import {Actions, StateChanges, BlankState} from './stateChanges'
import {AppConfig} from '../appConfig'
import axios from 'axios'
import StateValidation from './stateValidation'
import {NakdanType} from '@/simpleVsProConfig.js'
// import {bindFirebaseRef, createFirebaseRefs, firebaseLogout, syncData} from './firebaseModule'
// import savedExperiments from './savedExperimentUtils'

const NAKDAN_SERVER = AppConfig.SERVER
const GENRE_CLASSIFY_SERVER = 'https://nakdan.dicta.org.il/genreclassify'
axios.defaults.headers = {
  'Content-Type': 'text/plain;charset=UTF-8'
}
const axiosInstance = axios.create({timeout: 60000})
const invalidInput = false

// function ignoreSurrounders (allText) {
//   return allText.replace(/([^\s])[([{]([^\s]*)[)\]}]/g, "$1$2").replace(/[([{]([^\s])*[)\]}]([^\s])/g, "$1$2")
// }

function getMapForOriginalNikud (originalText, mapForOriginalNikud) {
  var fixedText = originalText.replace(/^[ְֱֲֳִֵֶַָׇֹֻּׁׂ]/g, '').replace(/([^א-תְֱֲֳִֵֶַָׇֹֻּׁׂ])[ְֱֲֳִֵֶַָׇֹֻּׁׂ]*/g, '$1') // remove all nikud not "on a letter"
  var justHebrew = fixedText.replace(/[^א-ת]/g, '')
  var justHebrewAndNikud = fixedText.replace(/[^א-תְֱֲֳִֵֶַָׇֹֻּׁׂ]/g, '')
  // console.log('justHebrewAndNikud: ' + justHebrewAndNikud)
  justHebrew.split('').forEach((ch, c) => {
    // console.log('char ' + c + ': ' + ch)
    justHebrewAndNikud = justHebrewAndNikud.slice(1)
    if ('ְֱֲֳִֵֶַָׇֹֻּׁׂ'.includes(justHebrewAndNikud[0])) {
      var nextLetter = justHebrewAndNikud.search(/[א-ת]/)
      // console.log('nextLetter:' + nextLetter)
      var nikudOnLetter = (nextLetter === -1) ? justHebrewAndNikud : justHebrewAndNikud.slice(0, nextLetter)
      justHebrewAndNikud = justHebrewAndNikud.slice(nikudOnLetter.length)
      mapForOriginalNikud.push({ letterIndex: c, letter: ch, nikudOnLetter: nikudOnLetter })
    }
  })
  console.log(Object.assign({}, mapForOriginalNikud))  
}

function getMapForRewrite (strippedText, mapForRewrite) {
  var textForApi = ''
  const whitespaceChars = [' ', '\t', '\r', '\n', '\v', '\f']
  strippedText.split('').forEach((ch, c) => {
    // console.log('char ' + c + ': ' + ch)
    var endOfLine = strippedText.slice(c).indexOf('\n')
    if ([-1, 0].includes(endOfLine)) endOfLine = strippedText.slice(c).length
    if ('()[]{}<>'.includes(ch) 
        || (ch === '?' && c < strippedText.length - 1 && !(whitespaceChars.includes(strippedText[c + 1])))
        || (whitespaceChars.includes(ch) && 
          ((textForApi.length === 0 && mapForRewrite.length)
            || !(strippedText.slice(c, c + endOfLine).split('').filter(x => !(('()[]{}<>' + whitespaceChars.join('')).includes(x))).length)))) {
      mapForRewrite.push({ charIndex: textForApi.length, charIgnored: ch })
      if (whitespaceChars.includes(ch)) {
        /* console.log('Whitespace pulled b/c ' + ((textForApi.length === 0 && mapForRewrite.length)
          ? 'textForApi.length === 0 && mapForRewrite.length'
          : "!(strippedText.slice(c).split('').filter(x => !('()[]{}<>' + whitespaceChars.join('').includes(x))).length)")) */
        // console.log('strippedText.slice(c):')
        // console.log(strippedText.slice(c))
        // console.log('endOfLine:')
        // console.log(endOfLine)
      }
    } else if (!(whitespaceChars.includes(ch) && (textForApi.length === 0
        || !(strippedText.slice(c).split('').filter(x => !(whitespaceChars.includes(x))).length)))) textForApi += ch
  })
  // console.log(Object.assign({}, mapForRewrite))  
  return textForApi
}

function assignOriginalNikudToTokens (responseData, mapForOriginalNikud) {
  var currentLetterIndex = 0
  var finished = mapForOriginalNikud.length === 0
  var currentNikudObj
  if (!finished) currentNikudObj = mapForOriginalNikud.shift()
  responseData.forEach(wordOrSep => {
    wordOrSep['originalNikud'] = ''
    wordOrSep.word.split('').forEach((ch) => {
      wordOrSep['originalNikud'] += ch
      if ('קראטוןםפשדגכעיחלךףזסבהנמצתץ'.includes(ch)) {
        if (!(wordOrSep.sep) && !finished && (currentNikudObj.letterIndex === currentLetterIndex)) {
          if (currentNikudObj.letter === ch) {
            wordOrSep['originalNikud'] += currentNikudObj.nikudOnLetter
            finished = mapForOriginalNikud.length === 0
            if (!finished) currentNikudObj = mapForOriginalNikud.shift()
          } else {
            console.log('mismatch in assignOriginalNikudToTokens():')
            console.log('currentLetterIndex: ' + currentLetterIndex + ', ch: ' + ch)
            console.log('Nikud.letter: ' + currentNikudObj.letter + ', nikudOnLetter: ' + currentNikudObj.nikudOnLetter)
          }
        }
        currentLetterIndex += 1
      }
    })
  })
}

function assignRewritesToTokens (responseData, mapForRewrite) {
  var c = 0
  responseData.forEach(wordOrSep => {
    wordOrSep['reinsertionChars'] = []
    while (mapForRewrite.length 
        && (mapForRewrite[0].charIndex < c + wordOrSep.word.length
            || (wordOrSep.sep && mapForRewrite[0].charIndex === c + wordOrSep.word.length))) {
      var charObj = mapForRewrite.shift()
      wordOrSep.reinsertionChars.push({ charIndex: charObj.charIndex - c, reinsertionChar: charObj.charIgnored })
      /* console.log('added reinsertionChars record to wordOrSep "' + wordOrSep.word.replace('\n', '\\n')
        + '" index ' + (charObj.charIndex - c) + ': "' + charObj.charIgnored.replace('\n', '\\n') + '"') */
    }
    c += wordOrSep.word.length
  })
  if (mapForRewrite.length) { 
    responseData[responseData.length-1].reinsertionChars.push(...(mapForRewrite.map(
      obj => { return { charIndex: obj.charIndex, reinsertionChar: obj.charIgnored }})))
  }
}

const nakdanSavedState = NakdanType.SavedStateName

export default {
  [Actions.INITIALIZE_APPLICATION]: function ({commit}) {
    var stateToCommit
    if (window.localStorage.hasOwnProperty(nakdanSavedState)) {
      var savedState
      let parseError = null
      const savedStateString = window.localStorage[nakdanSavedState]
      try {
        savedState = JSON.parse(savedStateString)
      }
      catch (error) {
        parseError = error
      }
      if (parseError || typeof savedState !== 'object' || savedState === null) {
        stateToCommit = Object.assign({}, BlankState, {
          validationResult: {
            summary: 'failure', savedStateString: window.localStorage[nakdanSavedState], failures: [{
              failureType: 'invalid ' + nakdanSavedState,
              errorData: parseError ? 'JSON parse error' : "not an 'object'"
            }]
          }
        })
      } else {
        savedState['validationResult'] = StateValidation.validateState(savedState)
        stateToCommit = savedState
      }
      if (stateToCommit.validationResult && stateToCommit.validationResult.summary === 'failure') {
        stateToCommit.validationResult['savedStateString'] = savedStateString
        // console.log('savedStateString:')
        // console.log(savedStateString)
        stateToCommit.validationResult['popupShown'] = false
      }
    } else stateToCommit = BlankState
    commit(StateChanges.SET_ENTIRE_STATE, {
      contextData: { wordIndex: 0, letterIndex: 0 }, // for undo
      newStateJson: JSON.stringify(stateToCommit)
    })
  },
  [Actions.RUN_NAKDAN]: function ({ commit, state }) {
    if (invalidInput) {
      console.log('Invalid input.')
      return
    }
    commit(StateChanges.NAKDAN_RUNNING)
    var textForApi = state.textForNakdanApiCall.text
    var mapForRewrite, mapForOriginalNikud
    if (state.preSubmissionOptions.skipVoc || state.preSubmissionOptions.skipPartVoc) {
      mapForOriginalNikud = []
      getMapForOriginalNikud(textForApi, mapForOriginalNikud) // mapForOriginalNikud is built by passing as reference
    }
    if (!(state.preSubmissionOptions.splitParens)) {
      mapForRewrite = []
      const strippedText = state.textForNakdanApiCall.text.replace(/[ְֱֲֳִֵֶַָׇֹֻּֽׁׂ\r]/g, '').trim() // the nakdan API will anyway
      textForApi = getMapForRewrite(strippedText, mapForRewrite) // mapForRewrite is built by passing as reference
    }
    axiosInstance.post(NAKDAN_SERVER, JSON.stringify({
      task: 'nakdan',
      genre: state.preSubmissionOptions.chosenTextTypeName,
      data: /* state.preSubmissionOptions.ignoreSurrounders ? ignoreSurrounders(state.textForNakdanApiCall.text) 
        : state.textForNakdanApiCall.text, */ textForApi,
      addmorph: true,
      keepqq: state.preSubmissionOptions.useQamatzQatan,
      nodageshdefmem: state.preSubmissionOptions.keepSourceDagesh,
      patachma: state.preSubmissionOptions.mahPatachDagesh,
      keepmetagim: true
      }))
      .then(function (response) {
        // console.log(textResponse)
        // const response = {data: JSON.parse(textResponse.data.replace(/(?<!"\S*)\d+(?!\S*")/g, "\"$&\"")) }
        // const response = {data: JSON.parse(textResponse.data.replace(/([[:])?(\d[\d.]*)([,}\]])/g, "$1\"$2\"$3")) }
        // console.log('response.data:')
        // console.log(response.data)
        if (!(state.preSubmissionOptions.splitParens)) {
          assignRewritesToTokens(response.data, mapForRewrite) // tokens are assigned rewrites by passing as reference
        }
        if (state.preSubmissionOptions.skipVoc || state.preSubmissionOptions.skipPartVoc) {
          assignOriginalNikudToTokens(response.data, mapForOriginalNikud) // tokens are assigned rewrites by passing as reference
        }
        commit(StateChanges.SET_NAKDAN_RESULTS, response.data)
        // console.log(response.data)
      })
      .catch(function (error) {
        if (error.code === 'ECONNABORTED') {
          commit(StateChanges.NAKDAN_TIMED_OUT)
        } else {
          console.log(error)
          commit(StateChanges.NAKDAN_FAILED)
        }
      })
    commit(StateChanges.GENRE_CLASSIFY_RUNNING)
    axiosInstance.post(GENRE_CLASSIFY_SERVER, JSON.stringify({
      data: textForApi,
      }))
      .then(function (response) {
        // console.log('genreClassifier response:')
        // console.log(response.data)
        commit(StateChanges.SET_GENRE_CLASSIFY_RESULTS, response.data)
      })
      .catch(function (error) {
        if (error.code === 'ECONNABORTED') {
          commit(StateChanges.GENRE_CLASSIFY_TIMED_OUT)
        } else {
          console.log(error)
          commit(StateChanges.GENRE_CLASSIFY_FAILED)
        }
      })
  }
}
